import React from 'react'
import { css, cx } from '@emotion/css'
import Downshift, { GetItemPropsOptions } from 'downshift'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { bodyCss } from '../text'
import { Popover } from './popover'
import { Placement } from '../popper'

interface OptionProps extends React.HTMLAttributes<HTMLDivElement> {
  readonly disabled?: boolean
  readonly testId?: string
}

export function MenuOption({
  className,
  disabled,
  testId,
  ...props
}: OptionProps) {
  return (
    <div
      data-testid={testId}
      className={cx(
        bodyCss,
        css`
          user-select: none;
          padding: 2px 10px;
          background-color: ${theme.color.white};
          transition: background-color 0.4s ease 0s;
        `,
        !disabled &&
          css`
            cursor: pointer;
            &:hover {
              background-color: ${theme.color.teal10};
            }
          `,
        disabled &&
          css`
            cursor: default;
            opacity: 0.4;
            pointer-events: none;
          `,
        className
      )}
      {...props}
    />
  )
}

export function Menu({ children }) {
  return (
    <div
      data-testid="popover-menu"
      className={cx(
        css`
          padding: 6px 0;
        `
      )}
      children={children}
    />
  )
}

export function MenuHr() {
  return (
    <hr
      className={css`
        margin-top: 6px;
        margin-bottom: 10px;
      `}
    />
  )
}

interface Props {
  readonly renderTarget: (props: {
    readonly isOpen: boolean
  }) => React.ReactElement<any>
  readonly renderMenu: (props: {
    readonly getItemProps: (options: GetItemPropsOptions<any>) => any
  }) => React.ReactElement<any>
  readonly placement?: Placement
  readonly close?: boolean
  readonly isOpenManual?: boolean | null
}

export function PopoverMenu({
  renderTarget,
  renderMenu,
  placement,
  close,
  isOpenManual
}: Props) {
  return (
    <Downshift>
      {({ isOpen, getToggleButtonProps, getItemProps, closeMenu }) => {
        return (
          <div>
            <Popover
              close={close}
              onClose={() => {
                closeMenu()
              }}
              isOpen={isOpenManual ?? isOpen}
              renderTarget={({ getTargetProps }) => {
                return (
                  <div {...getTargetProps()} {...getToggleButtonProps()}>
                    {renderTarget({ isOpen })}
                  </div>
                )
              }}
              placement={placement}
              renderContent={() => {
                return renderMenu({ getItemProps })
              }}
            />
          </div>
        )
      }}
    </Downshift>
  )
}
